module.exports = __webpack_public_path__ + "img/made_in_eu.6bb5346.svg";